import React, {
    forwardRef,
    useEffect,
    useImperativeHandle,
    useState,
} from "react";
import {User} from "react-feather";
import {FORMS, MODULES} from "../../const";
import {trailersMasterValidation} from "../validations/TrailersCreation";
import LoadingSpinner from "../LoadingSpinner";
import Input from "../input/Input";
import Dropdown from "../input/Dropdown";
import {getOtherRefSearchDropdown} from "../../api/keyvalue";
import SearchDropdown from "../input/SearchDropdown";
import InfoList from "../InfoList";
import {formatFromJsonDate} from "../../dateConfig";
import useUserCompany from "../../hooks/useUserCompany";

const FORM = FORMS.TRAILERS.TRL.form;
const TrailersAddComponent = forwardRef(
    ({errors, dropdown, isLoading, currentValues, editMode}, ref) => {
        const userCompany = useUserCompany();
        const [company, setCompany] = useState(
            userCompany ? userCompany.comId : null
          );
        
          useEffect(() => {
            setCompany(userCompany ? userCompany.comId : null);
          }, [userCompany]);
        
        const [trailerData, setTrailerData] = useState(
            editMode
                ? {
                    ...currentValues,
                    trl_id: currentValues.trl_id,
                    trlCompany: company,
                }
                : {
                    trlCode: "",
                    trlReference: "",
                    trlTransporter: "",
                    trlTrailerNo: "",
                    trlChassisNo: "",
                    trlYearManufacture: "",
                    trlTrailerType: "",
                    trlDescription: "",
                    trlTyres: "",
                    trlInsuranceExpiry: "",
                    trlDefaultTruck: "",
                    trlStatus: 2,
                    trlActive: 1,
                    trlCompany: company,
                },
        );
        const [searchFieldReset, setSearchFieldReset] = useState(false);
        const [currentErrors, setCurrentErrors] = useState({});
        useEffect(() => {
            setCurrentErrors(errors);
        }, [errors]);


        useImperativeHandle(ref, () => ({
            getData: () => trailerData,
            validateForm: () => {
                console.log("Trailer Data", trailerData);
                return trailersMasterValidation(trailerData);
            },
            resetForm: () => {
                setTrailerData({
                    trlCode: "",
                    trlReference: "",
                    trlTransporter: "",
                    trlChassisNo: "",
                    trlYearManufacture: "",
                    trlTyres: "",
                    trlInsuranceExpiry: "",
                    trlTrailerNo: "",
                    trlTrailerType: "",
                    trlDescription: "",
                    trlDefaultTruck: "",
                    trlStatus: 2,
                    trlActive: 1,
                });
            },
        }));


        return (
            <>
                {isLoading ? (
                    <LoadingSpinner/>
                ) : (
                    <form
                        className="ui form"
                        style={{overflowY: "auto", height: "75vh"}}
                    >
                        <div className="ui segment">
                            <h4 className="ui dividing header">Trailers</h4>
                            <div className="two fields">
                                <Input
                                    label="Trailer Code"
                                    module={MODULES.Master}
                                    form={FORM}
                                    field="trl_code"
                                    editMode={editMode}
                                    error={currentErrors.trlCode}
                                    resetError={() =>
                                        setCurrentErrors((prevState) => {
                                            const {trlCode: _, ...rest} = prevState;
                                            return rest;
                                        })
                                    }
                                    name="trailerCode"
                                    value={trailerData.trlCode}
                                    onChange={(e) => {
                                        setTrailerData((prevState) => ({
                                            ...prevState,
                                            trlCode: e.target.value,
                                        }));
                                    }}
                                    disabled={true}
                                />
                            </div>
                            <div className="two fields">
                                <Input
                                    required={true}
                                    label="Trailer Number"
                                    placeholder="trailer number"
                                    module={MODULES.Master}
                                    form={FORM}
                                    field="trl_trailor_no"
                                    editMode={editMode}
                                    error={currentErrors.trlTrailerNo}
                                    resetError={() =>
                                        setCurrentErrors((prevState) => {
                                            const {trlTrailerNo: _, ...rest} = prevState;
                                            return rest;
                                        })
                                    }
                                    name="trailerNumber"
                                    value={trailerData.trlTrailerNo}
                                    onChange={(e) => {
                                        setTrailerData((prevState) => ({
                                            ...prevState,
                                            trlTrailerNo: e.target.value,
                                        }));
                                    }}
                                />
                                <Input
                                    label="Trailer Reference"
                                    placeholder="trailer reference"
                                    module={MODULES.Master}
                                    form={FORM}
                                    field="trl_referance"
                                    editMode={editMode}
                                    error={currentErrors.trlReference}
                                    resetError={() =>
                                        setCurrentErrors((prevState) => {
                                            const {trlReference: _, ...rest} = prevState;
                                            return rest;
                                        })
                                    }
                                    name="trailerReference"
                                    value={trailerData.trlReference}
                                    onChange={(e) => {
                                        setTrailerData((prevState) => ({
                                            ...prevState,
                                            trlReference: e.target.value,
                                        }));
                                    }}
                                />
                            </div>
                            <div className="two fields">
                                <Dropdown
                                    required={true}
                                    label="Trailer Type"
                                    error={currentErrors.trlTrailerType}
                                    editMode={editMode}
                                    module={MODULES.Master}
                                    form={FORM}
                                    field="trl_trailor_type"
                                    resetError={() =>
                                        setCurrentErrors((prevState) => {
                                            const {trlTrailerType: _, ...rest} = prevState;
                                            return rest;
                                        })
                                    }
                                    options={dropdown.trailTypesOpt}
                                    style={{height: "20px"}}
                                    placeholder="Trailer Type"
                                    value={trailerData.trlTrailerType}
                                    onChange={(e, data) =>
                                        setTrailerData((prev) => ({
                                            ...prev,
                                            trlTrailerType: data.value,
                                        }))
                                    }
                                />
                                <SearchDropdown
                                    key={1}
                                    editMode={editMode}
                                    module={MODULES.Master}
                                    form={FORM}
                                    field="trl_transporter"
                                    reset={searchFieldReset}
                                    setReset={setSearchFieldReset}
                                    clearable={true}
                                    onClear={() => {
                                        setTrailerData((prevState) => ({
                                            ...prevState,
                                            trlTransporter:null,
                                        }));
                                    }}
                                    onResultSelect={(data) => {
                                        setTrailerData((prevState) => ({
                                            ...prevState,
                                            trlTransporter:data,
                                        }));
                                    }}
                                    api={getOtherRefSearchDropdown}
                                    apiDependency={{
                                        type: "stakeholder_type",
                                        value: "Transporter",
                                    }}
                                    fieldInfo={{
                                        tableName: "masterdata.tms_m_stakeholder",
                                        primaryKey: "stk_id",
                                        fieldName: "stk_name",
                                        id: trailerData.trlTransporter,
                                    }}
                                    label="Transporter"
                                    error={currentErrors.trlTransporter}
                                    resetError={() =>
                                        setCurrentErrors((prevState) => {
                                            const {trlTransporter: _, ...rest} = prevState;
                                            return rest;
                                        })
                                    }
                                />
                            </div>
                            <div className="two fields">
                                <Dropdown
                                    label="Tyre Size"
                                    error={currentErrors.trlTyres}
                                    editMode={editMode}
                                    module={MODULES.Master}
                                    form={FORM}
                                    field="trl_tyres"
                                    resetError={() =>
                                        setCurrentErrors((prevState) => {
                                            const {trlTyres: _, ...rest} = prevState;
                                            return rest;
                                        })
                                    }
                                    options={dropdown.tyreSizeOpt}
                                    style={{height: "20px"}}
                                    placeholder="Tyre Size"
                                    value={trailerData.trlTyres}
                                    onChange={(e, data) =>
                                        setTrailerData((prev) => ({
                                            ...prev,
                                            trlTyres: data.value,
                                        }))
                                    }
                                />
                                <Input
                                    label="Trailer insurance expiry"
                                    placeholder="insurance expiry"
                                    module={MODULES.Master}
                                    form={FORM}
                                    field="trl_insurance_expiry"
                                    editMode={editMode}
                                    error={currentErrors.trlInsuranceExpiry}
                                    resetError={() =>
                                        setCurrentErrors((prevState) => {
                                            const {trlInsuranceExpiry: _, ...rest} = prevState;
                                            return rest;
                                        })
                                    }
                                    name="trailerInsuranceExpiry"
                                    value={trailerData.trlInsuranceExpiry}
                                    onChange={(e) => {
                                        setTrailerData((prevState) => ({
                                            ...prevState,
                                            trlInsuranceExpiry: e.target.value,
                                        }));
                                    }}
                                />
                            </div>
                            <div className="two fields">
                                <Input
                                    label="Trailer Chassis Number"
                                    placeholder="chassis number"
                                    module={MODULES.Master}
                                    form={FORM}
                                    field="trl_chassis_no"
                                    editMode={editMode}
                                    error={currentErrors.trlChassisNo}
                                    resetError={() =>
                                        setCurrentErrors((prevState) => {
                                            const {trlChassisNo: _, ...rest} = prevState;
                                            return rest;
                                        })
                                    }
                                    name="trailerChassisNumber"
                                    value={trailerData.trlChassisNo}
                                    onChange={(e) => {
                                        setTrailerData((prevState) => ({
                                            ...prevState,
                                            trlChassisNo: e.target.value,
                                        }));
                                    }}
                                />
                                <Input
                                    label="Trailer Manufacture Year"
                                    placeholder="manufacture number"
                                    module={MODULES.Master}
                                    form={FORM}
                                    field="trl_year_manufacture"
                                    editMode={editMode}
                                    error={currentErrors.trlYearManufacture}
                                    resetError={() =>
                                        setCurrentErrors((prevState) => {
                                            const {trlYearManufacture: _, ...rest} = prevState;
                                            return rest;
                                        })
                                    }
                                    name="trailerManufactureNumber"
                                    value={trailerData.trlYearManufacture}
                                    onChange={(e) => {
                                        setTrailerData((prevState) => ({
                                            ...prevState,
                                            trlYearManufacture: e.target.value,
                                        }));
                                    }}
                                />
                            </div>
                            <div className="two fields">
                                <SearchDropdown
                                    key={2}
                                    editMode={editMode}
                                    module={MODULES.Master}
                                    form={FORM}
                                    field="trl_default_truck"
                                    reset={searchFieldReset}
                                    setReset={setSearchFieldReset}
                                    clearable={true}
                                    onClear={() => {
                                        setTrailerData((prevState) => ({
                                            ...prevState,
                                            trlDefaultTruck:null,
                                        }));
                                    }}
                                    onResultSelect={(data) => {
                                        setTrailerData((prevState) => ({
                                            ...prevState,
                                            trlDefaultTruck:data,
                                        }));
                                    }}
                                    api={getOtherRefSearchDropdown}
                                    apiDependency={{
                                        type: "vehicle",
                                        value: "",
                                    }}
                                    fieldInfo={{
                                        tableName: "masterdata.tms_m_vehicle_details",
                                        primaryKey: "veh_id",
                                        fieldName: "veh_vehicleno",
                                        id: trailerData.trlDefaultTruck,
                                    }}
                                    label="Default Truck"
                                    error={currentErrors.trlDefaultTruck}
                                    resetError={() =>
                                        setCurrentErrors((prevState) => {
                                            const {trlDefaultTruck: _, ...rest} = prevState;
                                            return rest;
                                        })
                                    }
                                />
                                <div
                                    className={`field ${
                                        currentErrors.trlDescription ? "error" : ""
                                    }`}
                                >
                                    <Input
                                        name="trailerDescription"
                                        label="Description"
                                        module={MODULES.Master}
                                        form={FORM}
                                        field="trl_description"
                                        editMode={editMode}
                                        placeholder="Description"
                                        error={currentErrors.trlDescription}
                                        resetError={() =>
                                            setCurrentErrors((prevState) => {
                                                const {trlDescription: _, ...rest} = prevState;
                                                return rest;
                                            })
                                        }
                                        value={trailerData.trlDescription}
                                        onChange={(e) => {
                                            setTrailerData((prevState) => ({
                                                ...prevState,
                                                trlDescription: e.target.value,
                                            }));
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="two fields">
                                <Dropdown
                                    label="Status"
                                    module={MODULES.Master}
                                    form={FORM}
                                    field="trl_status"
                                    editMode={editMode}
                                    error={currentErrors.trlStatus}
                                    resetError={() =>
                                        setCurrentErrors((prevState) => {
                                            const {trlStatus: _, ...rest} = prevState;
                                            return rest;
                                        })
                                    }
                                    placeholder="Status"
                                    options={dropdown.trailerStatusOpt}
                                    value={trailerData.trlStatus}
                                    style={{height: "20px"}}
                                    onChange={(e, data) => {
                                        setTrailerData((prevState) => ({
                                            ...prevState,
                                            trlStatus: data.value,
                                        }));
                                    }}
                                />
                                <Dropdown
                                    label="Active"
                                    // module={MODULES.Master}
                                    // form={FORM}
                                    field="trl_active"
                                    // authenticated={true}
                                    // needDeletePermission={true}
                                    editMode={editMode}
                                    error={currentErrors.trlActive}
                                    resetError={() =>
                                        setCurrentErrors((prevState) => {
                                            const {trlActive: _, ...rest} = prevState;
                                            return rest;
                                        })
                                    }
                                    placeholder="Active"
                                    options={dropdown.trailerActiveOpt}
                                    value={trailerData.trlActive}
                                    style={{height: "20px"}}
                                    onChange={(e, data) => {
                                        setTrailerData((prevState) => ({
                                            ...prevState,
                                            trlActive: data.value,
                                        }));
                                    }}
                                />
                            </div>
                        </div>
                        {editMode && (
                            <InfoList
                                title="User Information"
                                content={[
                                    {
                                        title: "Created By",
                                        value: trailerData.createdBy
                                            ? trailerData.createdBy
                                            : "N/A",
                                    },
                                    {
                                        title: "Created Date",
                                        value: trailerData.createdDate
                                            ? formatFromJsonDate(trailerData.createdDate)
                                            : "N/A",
                                    },
                                    {
                                        title: "Last Modified By",
                                        value: trailerData.lastModifiedBy
                                            ? trailerData.lastModifiedBy
                                            : "N/A",
                                    },
                                    {
                                        title: "Last Modified Date",
                                        value: trailerData.lastModifiedDate
                                            ? formatFromJsonDate(trailerData.lastModifiedDate)
                                            : "N/A",
                                    },
                                ]}
                                Icon={User}
                            />
                        )}
                    </form>
                )}
            </>
        );
    },
);

export default TrailersAddComponent;
